import { FC, useState } from "react";
import { SelectableMenuProps } from "../types";
import { Button, Menu, MenuItem } from "@mui/material";

export const SelectableMenu: FC<SelectableMenuProps> = (props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        disabled={props.options.length === 0}
        variant="outlined"
      >
        {props.label}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} sx={{ zIndex: 2001 }}>
        {props.options.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => {
              props.onSelect(option.value);
              handleClose();
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
